<template>
  <div>
    <TextFormGroup
        :value="value.content"
        name="content"
        label="Content"
        :error="(errors.content || [])[0]"
        @input="emit('content', $event)"
    />

    <TextFormGroup
        :value="value.link_url"
        name="link_url"
        label="Link URL"
        :error="(errors.link_url || [])[0]"
        @input="emit('link_url', $event)"
    />

    <TextFormGroup
        :value="value.link_text"
        name="link_text"
        label="Link Text"
        :error="(errors.link_text || [])[0]"
        @input="emit('link_text', $event)"
    />
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
